import { render, staticRenderFns } from "./productBanner.vue?vue&type=template&id=ac0c9736&scoped=true"
import script from "./productBanner.vue?vue&type=script&lang=js"
export * from "./productBanner.vue?vue&type=script&lang=js"
import style1 from "./productBanner.vue?vue&type=style&index=1&id=ac0c9736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0c9736",
  null
  
)

export default component.exports